import React, { useState, useEffect } from "react";
import axios from "axios";
import NavbarAdminLealtad from "../NavbarAdminLealtad/NavbarAdminLealtad";
import "../ListProv/ListProv.css";
import "./ListProvAdmin.css";
import FooterIndex from "../../components/footerHomePage/footerHomePage";
import moment from "moment";
import "moment/locale/es";
import Swal from "sweetalert2";

const ListProvAdmin = () => {
  moment.locale("es"); // Establecer español como idioma

  const [initialFilter, setInitialFilter] = useState({
    idSuplier: null,
    monthFilter: null,
    year: null,
  });
  const [apiResponse, setApiResponse] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [cuit, setCuit] = useState("");
  const [typeProvider, setTypeProvider] = useState("");
  const [sales, setSales] = useState([]);
  const [filtermonth, setFilterMonth] = useState(false);
  const [filtername, setfiltername] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      // Comprobar si monthFilter y year tienen valores
      if (
        initialFilter.monthFilter !== null &&
        initialFilter.year !== null &&
        initialFilter.idSuplier !== null
      ) {
        try {
          // Construir la URL con parámetros
          const response = await axios.get(
            `${process.env.REACT_APP_SALES_TOTALS_SUPPLIER_LEALTAD}${
              initialFilter.idSuplier
            }?month=${initialFilter.monthFilter}&year=${
              initialFilter.year
            }&timestamp=${new Date().getTime()}`
          );

          // Manejar la respuesta aquí
          setApiResponse(response.data);
        } catch (error) {
          console.error("Error al obtener datos:", error);
        }
      }
    };

    fetchData();
  }, [initialFilter]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SALES_ALL_SUPPLIER_LEALTAD
      );
      setSales(response.data);
    } catch (error) {}
  };

  const handleFilterClick = async () => {
    setfiltername(true);
    setSales([]); // Limpia las ventas al iniciar la búsqueda

    // Resetea el filtro inicial
    setInitialFilter((prev) => ({
      ...prev,
      idSuplier: null,
    }));

    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_SALES_ALL_SUPPLIER_LEALTAD
        }?timestamp=${new Date().getTime()}`,
        {
          params: {
            fromDate: fromDate,
            toDate: toDate,
            cuit: cuit,
            typeProvider: typeProvider,
          },
        }
      );

      const data = response.data;
      setSales(data); // Actualiza el estado de sales con los datos de la respuesta

      if (data.length > 0) {
        console.log(data);

        // Actualiza el filtro inicial basándote directamente en la respuesta recibida
        setInitialFilter((prev) => ({
          ...prev,
          idSuplier: data[0].supplierId || null,
        }));
      }
    } catch (error) {}
  };

  const handlertotalmonth = (response) => {
    return (
      <div className="allboxlistprov">
        <div className="headerlistprov">
          <p
            style={{ width: "25%" }}
            className="infoprovlistletterlealtad leftlistprevlealtad firtsborderlealtad"
          >
            Mes
          </p>
          <p
            style={{ width: "25%" }}
            className="infoprovlistletterlealtad leftlistprevlealtad"
          >
            Total Prestado
          </p>
          <p
            style={{ width: "25%" }}
            className="infoprovlistletterlealtad leftlistprevlealtad"
          >
            Porcentaje de Comisión
          </p>
          <p
            style={{ width: "25%" }}
            className="infoprovlistletterlealtad leftlistprevlealtad lastborderlealtad"
          >
            Total de la Comisión
          </p>
        </div>
        <div className="headerlistprovadmin marginlistprov" /* key={index} */>
          <p className="infoprovlistletterlealtad leftlistprev2lealtad">
            {response.salesTotal.month}
          </p>
          <p className="infoprovlistletterlealtad leftlistprev2lealtad">
            {response.salesTotal.totalBorrowed}
          </p>
          <p className="infoprovlistletterlealtad leftlistprev2lealtad">
            {response.salesTotal.commissionPercentage}
          </p>
          <p className="infoprovlistletterlealtad leftlistprev2lealtad">
            {response.salesTotal.totalCommission}
          </p>
        </div>
      </div>
    );
  };

  const handleFilterClickdate = async () => {
    setFilterMonth(true);
    try {
      const fromDateMoment = moment(fromDate, "YYYY-MM-DD");
      const toDateMoment = moment(toDate, "YYYY-MM-DD");

      /*--------------------------------------------------*/
      // Obtener el nombre del mes y el año en español
      const fromDateMonth = fromDateMoment.locale("es").format("MMMM");
      const fromDateYear = fromDateMoment.format("YYYY");

      const toDateMonth = toDateMoment.locale("es").format("MMMM");
      const toDateYear = toDateMoment.format("YYYY");

      // Comparar si el mes y el año son iguales
      if (fromDateMonth === toDateMonth && fromDateYear === toDateYear) {
        // Capitalizar la primera letra del mes
        const capitalizedMonth =
          fromDateMonth.charAt(0).toUpperCase() + fromDateMonth.slice(1);

        // Si el mes y el año son iguales, guardar en el filtro
        setInitialFilter((prev) => ({
          ...prev,
          monthFilter: capitalizedMonth,
          year: fromDateYear,
        }));
      }

      /*--------------------------------------------------*/

      // Calcular la diferencia en meses
      const differenceInMonths = toDateMoment.diff(fromDateMoment, "months");

      if (differenceInMonths > 3) {
        // La diferencia entre las fechas es mayor a 3 meses
        Swal.fire({
          icon: "warning",
          title: "Algo salió mal.",
          text: "La diferencia entre las fechas no puede ser mayor a 3 meses.",
        });
      } else {
        const response = await axios.get(
          process.env.REACT_APP_SALES_ALL_SUPPLIER_LEALTAD,
          {
            params: {
              fromDate: fromDate,
              toDate: toDate,
              cuit: cuit,
              typeProvider: typeProvider,
            },
          }
        );

        setSales(response.data);
      }
    } catch (error) {}
  };

  return (
    <div className="backgounrdprovlealtad">
      <NavbarAdminLealtad />
      <div className="allboxlistprovadminlealtad">
        <div className="allsearchlealtad">
          <div className="boxdisplaysearchlealtad">
            <div className="inputboxadminlealtad">
              <input
                className="inputsearchadminlealtad"
                id="inputfromDatelealtad"
                type="date"
                placeholder="Desde"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div className="inputboxadminlealtad">
              <input
                className="inputsearchadminlealtad"
                id="inputfromDatelealtad"
                type="date"
                placeholder="Hasta"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
            <div id="boxbuttondatelealtad">
              <button
                id="buttondatelealtad"
                className="buttonfilteradminlealtad"
                onClick={handleFilterClickdate}
              >
                Filtrar
              </button>
            </div>
          </div>
          <div className="boxdisplaysearchendlealtad">
            <div className="inputboxadminlealtad">
              <input
                className="inputsearchadminlealtad"
                type="text"
                placeholder="Buscar CUIT"
                value={cuit}
                onChange={(e) => setCuit(e.target.value)}
              />
            </div>
            <div>
              <button
                className="buttonfilteradminlealtad"
                onClick={handleFilterClick}
              >
                Buscar
              </button>
            </div>
          </div>
        </div>

        <div className="allsearch2lealtad">
          <div className="boxdisplaysearch2lealtad">
            <div className="inputboxadminlealtad">
              <input
                className="inputsearchadminlealtad"
                type="text"
                placeholder="Buscar Comercializador"
                value={typeProvider}
                onChange={(e) => setTypeProvider(e.target.value)}
              />
            </div>
            <div>
              <button
                className="buttonfilteradminlealtad"
                onClick={handleFilterClick}
              >
                Buscar
              </button>
            </div>
          </div>
        </div>

        <div className="alllistprovlealtad">
          <div className="headerlistprovadminlealtad">
            <p className="infoprovlistletterlealtad leftlistprevlealtad firtsborderlealtad">
              Nombre del Socio
            </p>
            <p className="infoprovlistletterlealtad leftlistprevlealtad">
              Fecha de prestamo
            </p>
            <p className="infoprovlistletterlealtad leftlistprevlealtad">
              Total
            </p>
            <p className="infoprovlistletterlealtad leftlistprevlealtad">
              Cuotas
            </p>
            <p className="infoprovlistletterlealtad bottonlistprevlealtad">
              Comision
            </p>
            <p className="infoprovlistletterlealtad bottonlistprevlealtad">
              Comercializador
            </p>
            <p className="infoprovlistletterlealtad bottonlistprevlealtad lastborderlealtad">
              Cuit
            </p>
          </div>
          {sales.map((sale, index) => (
            <div
              className="headerlistprovadminlealtad marginlistprovlealtad"
              key={index}
            >
              <p className="infoprovlistletterlealtad leftlistprev2lealtad">
                {sale.nameOfPersonReceivingLoan}
              </p>
              <p className="infoprovlistletterlealtad leftlistprev2lealtad">
                {moment(sale.date).format("DD-MM-YYYY")}
              </p>
              <p className="infoprovlistletterlealtad leftlistprev2lealtad">
                ${sale.amountGranted}
              </p>
              <p className="infoprovlistletterlealtad leftlistprev2lealtad">
                {sale.quotas}
              </p>
              <p className="infoprovlistletterlealtad bottonlistprev2lealtad">
                ${sale.commission}
              </p>
              <p className="infoprovlistletterlealtad bottonlistprev2lealtad">
                {sale.typeProvider}
              </p>
              <p className="infoprovlistletterlealtad bottonlistprev2lealtad">
                {sale.cuitProvider}
              </p>
            </div>
          ))}
        </div>
      </div>

      {filtername && filtermonth && apiResponse
        ? handlertotalmonth(apiResponse)
        : null}

      <FooterIndex />
    </div>
  );
};

export default ListProvAdmin;
